import { styled } from '@mui/system'
import { Grid as GridBase } from '@mui/material'

export const Container = styled(GridBase)(() => ({
  height: '400px',
}))

export const Grid = styled(GridBase)(() => ({}))
